<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('base.linePrice.pickupPoint')" prop="pickupPoint">
                    <el-input class="handle-input" v-model="queryCondition.pickupPoint" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('base.linePrice.dc')" prop="tmDcId">
                    <ic-select table="BASE" field="DC" v-model="queryCondition.tmDcId" filterable clearable style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('base.linePrice.temperature')" prop="temperature">
                    <el-select v-model="queryCondition.temperature" class="handle-input" style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in temperatureList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('base.linePrice.unit')" prop="unit">
                    <el-select v-model="queryCondition.unit" class="handle-input" style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in unitList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('base.linePrice.transportaionMethod')" prop="transportaionMethod">
                      <el-select v-model="queryCondition.transportaionMethod" class="handle-input" style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('base.linePrice.currencyCode')" prop="tcCurrencyId">
                      <el-select v-model="queryCondition.tcCurrencyId" class="handle-input" style="width:100%">
                        <el-option :label="$t('common.all')" value=""></el-option>
                        <el-option :key="index" v-for="(item,index) in currencyList" :label="item.currencyCode" :value="item.tcCurrencyId"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="有效开始日期(从)" prop="beginDate">
                      <el-date-picker style="width:100%" value-format="yyyy-MM-dd" v-model="queryCondition.beginDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="有效开始日期(至)" prop="endDate">
                      <el-date-picker style="width:100%" value-format="yyyy-MM-dd" v-model="queryCondition.endDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="承运商" prop="tmSupplierId" class="handle-input">
                      <ic-select table="BASE" field="CARRIER" v-model="queryCondition.tmSupplierId" filterable clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="ApplyLineChangeInit" @click="createQuotationApply">{{$t('base.linePrice.update')}}</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="LineExport" @click="exportData">{{$t('base.linePrice.export')}}</el-button>
      </el-row>
      <el-table :data="tableData" ref="lineDataRef" border max-height='520' highlight-current-row @selection-change="handleSelectionChange">
        <el-table-column sortable type="selection" width="55" align="center" fixed="left"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="lineType" min-width="100" align="center" :label="$t('base.linePrice.lineType')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="pickupPoint" min-width="80" align="center" :label="$t('base.linePrice.pickupPoint')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="dcName" min-width="100" align="center" :label="$t('base.linePrice.dc')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="temperatureI18n" min-width="80" align="center" :label="$t('base.linePrice.temperature')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="transportaionMethodI18n" min-width="90" align="center" :label="$t('base.linePrice.transportaionMethod')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierName" align="center" min-width="90" :label="$t('base.linePrice.supplier')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="unitI18n" align="center" min-width="100" :label="$t('base.linePrice.unit')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="effectiveBeginDate" min-width="120" align="center" :label="$t('base.linePrice.effectiveBeginDate')">
          <template slot-scope="scope">
            {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="price" align="center" min-width="120" :label="$t('base.linePrice.price')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="currencyCode" align="center" min-width="90" :label="$t('base.linePrice.currencyCode')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="leadTime" align="center" min-width="100" label="LeadTime"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" align="center" min-width="120" :label="$t('base.linePrice.confirmDate')">
          <template slot-scope="scope">
            {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable align="center" :label="$t('base.linePrice.operation')" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary" @click="queryLineDetail(scope.row)"> {{$t('base.linePrice.history')}} </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { search, downloadFile } from "../../../api/base-data/linePriceData";
import { Message } from "element-ui";
import { inputChoiceService } from "../../../api/common/input-choice";
import lineDetail from './linePriceDataDetail';
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
import commonFunction from "../../../utils/dataTableUtils"
export default {
  name: 'linePriceData',
  mixins: [paginationMixin],
  components: {
    lineDetail,
    IcSelect
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      tableData: [],
      totalCount: 0,
      labelPosition: 'right',
      unitList: [],
      currencyList: [],
      temperatureList: [],
      transportaionMethodList: [],
      tmPickupId: '',
      temperature: '',
      tmDcId: '',
      transportaionMethod: '',
      linePriceDetailDialog: false,
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        pickupPoint: '',
        tmDcId: '',
        temperature: '',
        unit: '',
        transportaionMethod: '',
        tcCurrencyId: '',
        beginDate: '',
        endDate: '',
        tmSupplierId: '',
        lineIdList: [],
      },
      emplFlag: '',
      multipleSelection: [],
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    search(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  created() {
    // this.queryData(1);
    this.getInputChoiceValues();
    //用户所属系统
    this.emplFlag = localStorage.getItem('ms_emplFlag');
  },
  methods: {
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      search(this.queryCondition).then((res) => {
        setTimeout(() => {
          this.tableData = res.resultData;
          this.totalCount = res.totalCount;
        }, 1000);
      })
    },
    queryLineDetail(row) {
      if (this.actionCheck.actionCheck('linePriceSeeHistory') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.replace({ name: 'linePriceDetail', params: { tmPickupId: row.tmPickupId, temperature: row.temperature, tmDcId: row.tmDcId, transportaionMethod: row.transportaionMethod } });
    },
    exportData() {
      console.log('this.queryCondition', this.queryCondition);
      downloadFile(this.queryCondition).then((res) => {
        fileService.respToFile(res);
      })
    },
    handleSelectionChange(val) {
      this.queryCondition.lineIdList = []
      this.multipleSelection = val;
      val.forEach(ele => {
        this.queryCondition.lineIdList.push(ele.tmLineId)
      })
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:UNIT"] = "COMMON:UNIT";
      mapObj["TT_QUOTATION_APPLY_LINE:TEMPERATURE"] = "TT_QUOTATION_APPLY_LINE:TEMPERATURE";
      mapObj["TT_QUOTATION_APPLY_LINE:TRANSPORTAION_METHOD"] = "TT_QUOTATION_APPLY_LINE:TRANSPORTAION_METHOD";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.unitList = res["COMMON:UNIT"];
        this.temperatureList = res["TT_QUOTATION_APPLY_LINE:TEMPERATURE"];
        this.transportaionMethodList = res["TT_QUOTATION_APPLY_LINE:TRANSPORTAION_METHOD"];
      });
      inputChoiceService.getCurrencyList().then((res) => {
        this.currencyList = res;
      });
    },
    //查询条件重置方法
    restQueryForm() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        pickupPoint: '',
        tmDcId: '',
        temperature: '',
        unit: '',
        transportaionMethod: '',
        tcCurrencyId: '',
        beginDate: '',
        endDate: '',
        tmSupplierId: '',
      }
      this.queryData();
    },
    //线路变更申请单
    createQuotationApply: function () {
      let rows = this.$refs.lineDataRef.selection;
      console.log('rows', rows);
      if (rows.length == 0) {
        Message({ message: this.$t('base.linePrice.selUpdataData'), type: "warning" });
      } else {
        let lineId = [];
        let supSet = new Set();
        rows.forEach((item) => {
          lineId.push(item.tmLineId);
          supSet.add(item.tmSupplierId);
        });
        if (supSet.size > 1) {
          Message({ message: '线路变更申请单，只能变更相同供应商的线路!', type: "warning" });
          return;
        }
        if (this.emplFlag == 'SUP') {
          this.$router.replace({ name: 'applyChangeLine', params: { applyId: lineId, source: 'SUP' } });
        } else {
          this.$router.replace({ name: 'applyChangeLine', params: { applyId: lineId, source: 'MCD' } });
        }
      }
    }
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.dialog-input {
  width: 40%;
}
</style>
